import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class AllCustomersTitleBar extends Component {

    render() {
        return (

            <div className="title-1 text-align-left">
                <FormattedMessage id="app.all-customers-title-bar.title"
                                  defaultMessage="CUSTOMERS"/>
            </div>

        )
    }
}
export default AllCustomersTitleBar;


// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersTitleBar/AllCustomersTitleBar.js